module.exports = __webpack_public_path__ + "media/promo/panasonic/images/soc-1-eda7deeeb96f7e012c0959ff16fb273b.svg";